import React, { useEffect } from 'react'
import './alert-message.css'
import { InformationIcon } from '@paypalcorp/pp-react'

export interface IAlertMessageProps {
  type?: 'info'
  title?: string
  className?: string
}
export const AlertMessage: React.FC<IAlertMessageProps> = ({
  type = 'info',
  title,
  children,
  className = '',
}) => {
  const alertClassName = `alert_message-${type}`

  const defaultTitle = {
    info: 'Note: ',
    note: 'Note: ',
    important: 'Important: ',
    tip: 'Tip: ',
  }

  return (
    <>
      <div className={`alert_message ${alertClassName} ${className}`}>
        <InformationIcon className={`${alertClassName}-icon`} />
        <p>
          <b style={{ marginRight: '0.2em' }}>
            {title ? { title } : defaultTitle[type]}
          </b>
          {children}
        </p>
      </div>
    </>
  )
}

export default AlertMessage
